import React, {useEffect, useState} from "react";
import {ListComponent} from "../../components/List";
import {HeaderContainer} from "../Header";
import {AddListModal} from "../AddListModal";
import {DemoListData} from "./sampleData";
import {AddAccountModal} from "../AddAccountModal";

import styles from "./css/demo.module.scss";
import {DeleteListModal} from "../DeleteListModal";
import {useDispatch, useSelector} from "react-redux";
import {DemoSetSNSLists} from "../../actions";
import {AccountListDialog} from "../../components/AccountListDialog";
import {DeleteAccountRequest, SNSDataList} from "../../util/api";
import {DeleteAccountDialog} from "../DeleteAccountDialog";

export const DemoContainer: React.FC = (props: any) => {
    const demoListSelector = (state: any) => state.demoSnsLists;
    const dispatch = useDispatch();

    const [open, setOpen] = useState(false);
    const [addAccountOpen, setAddAccountOpen] = useState(false);
    const [deleteListOpen, setDeleteListOpen] = useState(false);
    const [accountListOpen, setAccountListOpen] = useState(false);
    const [deleteAccountOpen, setDeleteAccountOpen] = useState(false);
    const [
        deleteAccountRequest,
        setDeleteAccountRequest,
    ] = useState<DeleteAccountRequest | null>(null);
    const [selectedListId, setSelectedListId] = useState(0);

    useEffect(() => {
        dispatch(DemoSetSNSLists(DemoListData));
    }, [dispatch]);

    const snsLists = useSelector(demoListSelector);

    return (
        <>
            <HeaderContainer setOpen={setOpen} />
            <div className={styles.wrap}>
                <ListComponent
                    lists={snsLists}
                    setOpenModal={setOpen}
                    setOpenAddAccount={setAddAccountOpen}
                    setOpenDeleteList={setDeleteListOpen}
                    setOpenAccountList={setAccountListOpen}
                    setSelectedList={setSelectedListId}
                />
            </div>
            <AddListModal isOpen={open} setOpen={setOpen} isDemo={true} />
            <AddAccountModal
                isOpen={addAccountOpen}
                setOpen={setAddAccountOpen}
                selectedList={selectedListId}
                isDemo={true}
            />
            <DeleteListModal
                isOpen={deleteListOpen}
                setOpen={setDeleteListOpen}
                selectedList={selectedListId}
                isDemo={true}
            />
            <AccountListDialog
                isOpen={accountListOpen}
                setOpen={setAccountListOpen}
                setAddAccountOpen={setAddAccountOpen}
                setDeleteAccountOpen={setDeleteAccountOpen}
                setDeleteAccountRequest={setDeleteAccountRequest}
                list={snsLists.find(
                    (l: SNSDataList) => l.id === selectedListId
                )}
            />
            <DeleteAccountDialog
                isOpen={deleteAccountOpen}
                setOpen={setDeleteAccountOpen}
                selectedList={selectedListId}
                account={deleteAccountRequest}
                snsLists={snsLists}
                isDemo={true}
            />
        </>
    );
};
